import { useEffect, useState } from 'react';
import { API_ORIGIN, cmsAPI } from '../utils/api';

export default function GoogleLoginButton({ label = 'Continue with Google' }) {
  const [redirectUrl, setRedirectUrl] = useState('');
  const [checkedConfig, setCheckedConfig] = useState(false);

  useEffect(() => {
    const controller = new AbortController();
    cmsAPI.siteConfig({ signal: controller.signal }).then(({ data }) => {
      if (data.data?.google_login?.enabled) {
        setRedirectUrl(data.data.google_login.redirect_url || `${API_ORIGIN}/api/v1/auth/google/redirect`);
      }
      setCheckedConfig(true);
    }).catch((error) => {
      if (error.code !== 'ERR_CANCELED') console.error('Unable to load Google login config.');
      setCheckedConfig(true);
    });

    return () => controller.abort();
  }, []);

  if (!redirectUrl) {
    if (checkedConfig && import.meta.env.DEV) {
      return (
        <div className="rounded border border-yellow-400/30 bg-yellow-400/10 px-4 py-3 text-sm text-yellow-100" role="status">
          Google login is hidden until it is enabled in Admin &gt; Business &amp; Google setup with a client ID and secret.
        </div>
      );
    }

    return null;
  }

  return (
    <a href={redirectUrl} className="flex w-full items-center justify-center gap-3 rounded border border-gray-700 bg-white px-4 py-3 font-semibold text-gray-900 hover:bg-gray-100">
      <span className="flex h-5 w-5 items-center justify-center rounded-full bg-white text-sm font-bold text-blue-600">G</span>
      {label}
    </a>
  );
}
